import styled from "styled-components";
import {
  questionDarkTextColor,
  questionTextColor,
  whiteColor,
  blackColor,
  darkColor,
  greyTextColor,
  purpleLightColor,
} from "./constants/colors";
import orangeBullet from "./resources/images/icons/orange_bullet.svg";

const Container = styled.div`
  padding-right: 20px;
  padding-left: 20px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  box-sizing: border-box;
  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }
  @media (min-width: 1200px) {
    width: 1150px;
  }
  div,
  p {
    -webkit-tap-highlight-color: transparent;
  }
`;

Container.Content = styled.div`
  max-width: 571px;
  width: 100%;
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
  z-index: 1;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  div,
  p {
    -webkit-tap-highlight-color: transparent;
  }
`;

Container.Items = styled.div`
  background: ${(props) => props.bgColor || "#ffffff"};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 25px 12px;
  border: ${(props) => props.border || "none"};
  position: relative;
`;
// исп
const Heading = styled.h1`
  font-family: SF, sans-serif;
  font-weight: 800;
  font-size: 34px;
  line-height: 44px;
  color: ${whiteColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 34px;
    line-height: 44px;
  }
`;
// исп
Heading.Second = styled.h2`
  font-family: SF, sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  margin: 0;
  color: ${questionTextColor};
  @media (max-width: 767px) {
    font-size: 22px;
    line-height: 26px;
  }
`;
// исп
Heading.Third = styled.h3`
  font-family: SF, sans-serif;
  font-weight: 800;
  font-size: 22px;
  line-height: 28.6px;
  margin: 0;
  color: ${darkColor};
  @media (max-width: 767px) {
    font-size: 22px;
    line-height: 28.6px;
  }
`;
// исп
Heading.Fourth = styled.h3`
  font-family: SF, sans-serif;
  font-weight: 800;
  font-size: 26px;
  line-height: 34px;
  margin: 0;
  color: ${darkColor};
  @media (max-width: 767px) {
    font-size: 26px;
    line-height: 34px;
  }
`;

Heading.Fifth = styled.h3`
  font-family: SF, sans-serif;
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  margin: 0;
  color: #575460;
  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 21px;
  }
`;

//исп
const Text = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 19px;
  line-height: 21px;
  color: ${questionDarkTextColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 19px;
    line-height: 21px;
  }
  span {
    &.decor {
      &.decor {
        position: relative;
        color: #000;
        text-decoration: none;
        width: 112px;
      }
      &.decor:before {
        content: "";
        border-bottom: 2px solid
          ${(props) =>
            props.theme === "dark" ? purpleLightColor : greyTextColor};
        position: absolute;
        width: 100%;
        height: 50%;
        transform: rotate(0deg);
      }
    }
  }
  &.decor {
    position: relative;
    color: #000;
    text-decoration: none;
    width: 112px;
  }
  &.decor:before {
    content: "";
    border-bottom: 2px solid #e24b4b;
    position: absolute;
    width: 85%;
    height: 50%;
    transform: rotate(-12deg);
  }
`;
//исп
Text.Second = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  color: ${questionDarkTextColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 26px;
  }
`;

//исп
Text.Third = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  color: ${questionDarkTextColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 23px;
  }
`;

//исп
Text.Fourth = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: ${darkColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 21px;
  }
`;

//исп
Text.Fifth = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${questionDarkTextColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

//исп
Text.Six = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  color: ${whiteColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

Text.Seventh = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 16.5px;
  color: #575460;
  margin: 0;
  @media (max-width: 767px) {
    font-size: 15px;
    line-height: 16.5px;
  }
`;

Text.Eight = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 15.6px;
  color: #fee4a0;
  margin: 0;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  @media (max-width: 767px) {
    font-size: 12px;
    line-height: 15.6px;
  }
`;

Text.Process = styled.p`
  font-family: SF, sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: ${darkColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

Text.Comment = styled.p`
  font-family: SF, sans-serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 29px;
  color: ${darkColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 22px;
    line-height: 29px;
  }
`;

Text.Comment.SemiBold = styled.p`
  font-family: SF, sans-serif;
  font-weight: 500;
  font-size: 22px;
  line-height: 29px;
  color: ${darkColor};
  margin: 0;
  text-align: left;
  @media (max-width: 767px) {
    font-size: 22px;
    line-height: 29px;
  }
`;

Text.Comment.Name = styled.p`
  font-family: SF, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: ${darkColor};
  margin: 0;
  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 21px;
  }
`;

Text.Button = styled.p`
  font-family: SF, sans-serif;
  font-weight: ${(props) => (props.type === "default" ? 700 : 700)};
  font-size: ${(props) => (props.type === "default" ? "18px" : "22px")};
  line-height: ${(props) => (props.type === "default" ? "20px" : "26px")};
  color: ${(props) => (props.type === "default" ? blackColor : whiteColor)};
  margin: 0;
  @media (max-width: 767px) {
    font-size: ${(props) => (props.type === "default" ? "22px" : "22px")};
    line-height: ${(props) => (props.type === "default" ? "26px" : "26px")};
  }
`;

const ImageItem = styled.div`
  display: flex;
  align-items: flex-start;
`;

ImageItem.Img = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: rgba(69, 62, 164, 0.5);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.22);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 18px;
`;

ImageItem.Text = styled.div`
  display: flex;
  align-items: center;
  min-height: 30px;
`;

const ThemeWrapper = styled.div`
  padding-top: 45px;
  position: relative;
  background: ${(props) => props.bgColor || "#e0dff0"};
  flex-grow: 1;
  overflow: hidden;
  .blue {
    position: absolute;
    top: 0;
    left: 0;
  }
  .purple {
    position: absolute;
    top: 300px;
    right: 0;
  }
`;

const List = styled.div``;

List.Item = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

List.Item.Bullet = styled.div`
  background: url(${(props) => props.bulletImg || orangeBullet});
  background-repeat: no-repeat;
  min-width: 6px;
  min-height: 6px;
  margin-right: 11px;
  margin-top: 7px;
`;

List.Item.Text = styled.div`
  text-align: left;
`;

const HalfColumn = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

HalfColumn.Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  box-sizing: border-box;
  margin-bottom: 36px;
`;

HalfColumn.Item.Icon = styled.div`
  margin-bottom: 6px;
`;

HalfColumn.Item.Text = styled.div``;

export { Container, Heading, Text, ImageItem, ThemeWrapper, List, HalfColumn };
